export enum CategoryType {
  tagger = 'tagger',
}
